import React, { Component } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { Divider, Form, Message, Button } from 'semantic-ui-react';

import { RECAPTCHA_SITE_KEY, AWS_CONTACT_ENDPOINT } from '../constants';

class ContactForm extends Component {
  state = {
    error: false,
    success: false,
    contactData: {
      'g-recaptcha-response': '',
      name: '',
      email: '',
      phone: '',
      message: '',
    },
  };

  onChange(response) {
    const { contactData } = this.state;
    contactData['g-recaptcha-response'] = response;
    this.setState({ contactData });
  }

  handleChange(field, { target: { value } }) {
    const { contactData } = this.state;
    contactData[field] = value;
    this.setState({ contactData });
  }

  handleContactSubmission = e => {
    e.preventDefault();
    const { contactData } = this.state;
    fetch(AWS_CONTACT_ENDPOINT, {
      method: 'POST',
      body: JSON.stringify(contactData),
    });
    this.setState({
      success: true,
      contactData: {
        'g-recaptcha-response': '',
        name: '',
        email: '',
        phone: '',
        message: '',
      },
    });
  };

  render() {
    const { contactData, error, success } = this.state;
    const successMessage = `The team is focused on product development right \
    now, but we&apos;ll pass that on to the appropriate team member.`;
    const errorMessage = `There was a problem with your submission sorry. \
    Please check and resubmit your email, or contact us at info@tribevibe.com`;

    return (
      <div>
        <Divider style={{ padding: '1em' }} />
        <Form
          onSubmit={this.handleContactSubmission}
          error={Boolean(error)}
          success={Boolean(success)}
        >
          <Message
            success
            header="Thanks for your message"
            content={successMessage}
          />
          <Message
            error
            header="Oops! Something Went Wrong"
            content={errorMessage}
          />
          <Form.Input
            value={contactData.name}
            id="name"
            onChange={this.handleChange.bind(this, 'name')}
            label="Your name"
            placeholder="Your full name"
          />
          <Form.Input
            value={contactData.email}
            id="email"
            onChange={this.handleChange.bind(this, 'email')}
            label="Email address"
            placeholder="Add email address"
            type="email"
            required
          />
          <Form.Input
            value={contactData.phone}
            id="phone"
            onChange={this.handleChange.bind(this, 'phone')}
            label="Phone contact"
            placeholder="Phone"
          />
          <Form.TextArea
            value={contactData.message}
            id="message"
            onChange={this.handleChange.bind(this, 'message')}
            label="Your message"
            placeholder="Please enter your message here"
          />
          <ReCAPTCHA
            ref="recaptcha"
            sitekey={RECAPTCHA_SITE_KEY}
            onChange={this.onChange.bind(this)}
          />
          <Button
            type="submit"
            content="Submit"
            disabled={contactData['g-recaptcha-response'] === ''}
          />
        </Form>
      </div>
    );
  }
}

export default ContactForm;



// WEBPACK FOOTER //
// ./src/components/ContactForm.js